import './App.css';
import { ReactComponent as FirstpC } from './FirstP_Clear.svg';
import { ReactComponent as SecondpC } from './SecondP_Clear.svg';
import { ReactComponent as ThirdpC } from './ThirdP_Clear.svg';
import { ReactComponent as FourthpC } from './FourthP_Clear.svg';
import { ReactComponent as FifthpC } from './FifthP_Clear.svg';
import { ReactComponent as SixthpC } from './SixthP_Clear.svg';

import { ReactComponent as Logo } from './logoup.svg';
import { ReactComponent as Peacock } from './peacock1.svg';
import { ReactComponent as Line } from './line.svg';
import { ReactComponent as ArrowForward } from './arrow_forward.svg';
import { ReactComponent as Close } from './close.svg';
import { ReactComponent as Undo } from './undo.svg';
import { ReactComponent as Redo } from './redo.svg';
import { ReactComponent as SideBar } from './sidebar.svg';
import { ReactComponent as Slider } from './Vector.svg';
import { ReactComponent as FirstP } from './FirstP.svg';
import { ReactComponent as SecondP } from './SecondP.svg';
import { ReactComponent as ThirdP } from './ThirdP.svg';
import { ReactComponent as FourthP } from './FourthP.svg';
import { ReactComponent as FifthP } from './FifthP.svg';
import { ReactComponent as SixthP } from './SixthP.svg';
import styled from 'styled-components';
import { useEffect, useRef, useState } from 'react';
import Patterns from './Patterns';
import firstPdata from './firstP.json'
import secondPdata from './secondP.json'
import thirdPdata from './thirdP.json'
import fourthPdata from './fourthP.json'
import fifthPdata from './fifthP.json'
import sixthPdata from './sixthP.json'
import React from 'react'
import firstpJson from './firstP.json'
import secondpJson from './secondP.json'
import thirdpJson from './thirdP.json'
import fourthpJson from './fourthP.json'
import fifthpJson from './fifthP.json'
import sixthpJson from './sixthP.json'
import html2pdf from 'html2pdf.js';
import FullScreenGrid from './FullScreenGrid';
import DownloadModal from './DownloadModal';


const allJsons = [firstpJson, secondpJson, thirdpJson, fourthpJson, fifthpJson, sixthpJson];

const extractUniqueClasses = () => {
    const uniqueClasses = new Set();

    allJsons.forEach(json => {
        json.colorCode.forEach(color => {
            color.class.forEach(className => {
                uniqueClasses.add(className);
            });
        });
    });

    return Array.from(uniqueClasses);
};

const existingClasses = extractUniqueClasses();
localStorage.setItem('existingClasses', JSON.stringify(existingClasses));
function App() {

    const [step, setStep] = useState(0);
    const [grid, setGrid] = useState(null)
    const [selectedColor, setSelectedColor] = useState('red');
    const [history, setHistory] = useState([]);
    const [redoStack, setRedoStack] = useState([]);
    const [clickedButton, setClickedButton] = useState(null);
    const [selectedPattern, setSelectPattern] = useState({});
    const [indices, setIndices] = useState([]);
    const [selectedClass, setSelectedClass] = useState(null);


    const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
    const contentRef = useRef(null); // Add this for capturing content





    const handleClick = (buttonName, action) => {
        setClickedButton(buttonName);
        if ((buttonName != 'forward') && (buttonName != 'back') && buttonName != 'story') {
            action();
        }
        setTimeout(() => setClickedButton(null), 200); // Reset effect after 200ms
    };

    const clickedShadow = 'inset -3px -3px 3px 0px #FFFFFF, inset 3px 3px 3px 0px #00000033';
    const defaultShadow = '-3px -3px 6px 0px #FFFFFF, 3px 3px 6px 0px #00000033';

    const svgRefs = useRef(Array.from({ length: 1 }, () => null));

    useEffect(() => {
        svgRefs.current.forEach((svgRef, svgIndex) => {
            if (svgRef) {
                const rects = svgRef.querySelectorAll('path');

                rects.forEach((rect, index) => {
                    const savedColor = localStorage.getItem(`rect-${index}`);
                    if (savedColor) {
                        rect.style.fill = savedColor;
                    } else {
                        rect.style.fill = 'white';
                    }
                    if (svgIndex === 0) {
                        rect.addEventListener('click', (e) => handleCellClick(e, rect, index));
                        rect.style.cursor = 'pointer';
                    }
                });
            }
        });
    }, [selectedColor]);


    useEffect(() => {
        indices.forEach((index) => {
            svgRefs.current.forEach((svgRef) => {
                if (svgRef) {
                    const rects = svgRef.querySelectorAll('path');
                    if (rects[index]) {
                        rects[index].style.fill = selectedColor;
                        localStorage.setItem(`rect-${index}`, selectedColor);
                    }
                }
            });
        });
    }, [indices])

    const updateFromLocalStorage = () => {
        const storedClass = JSON.parse(localStorage.getItem('selectedClass')) || [];
        setSelectedClass(storedClass);

        existingClasses.forEach((className) => {
            const elements = document.querySelectorAll(`.${className}C`);
            if (storedClass.includes(className)) {
                elements.forEach((element) => element.classList.add('show'));
            } else {
                elements.forEach((element) => element.classList.remove('show'));
            }
        });
    };


    useEffect(() => {
        const updateFromLocalStorage = () => {
            const storedColor = localStorage.getItem('selectedColor');
            const storedClass = JSON.parse(localStorage.getItem('selectedClass'));

            if (storedColor) {
                setSelectedColor(storedColor);
            }

            if (storedClass) {
                setSelectedClass(storedClass);
                const applyClassToggle = () => {
                    existingClasses.forEach((className) => {
                        const elements = document.querySelectorAll(`.${className}C`);
                        if (storedClass.includes(className)) {
                            elements.forEach(element => {
                                element.classList.add('show');
                            });
                        } else {
                            elements.forEach(element => {
                                element.classList.remove('show');
                            });
                        }
                    });
                };

                // Run after the elements are rendered
                setTimeout(applyClassToggle, 3);
            }
        };

        // Initial load
        console.log("Loading from localStorage");
        updateFromLocalStorage();

        // Listen for changes in localStorage
        const handleStorageChange = () => {
            console.log("Storage changed");
            updateFromLocalStorage();
        };

        window.addEventListener('storage', (event) => {
            if (event.key === 'selectedColor' || event.key === 'selectedClass') {
                handleStorageChange();
            }
        });

        return () => {
            window.removeEventListener('storage', (event) => {
                if (event.key === 'selectedColor' || event.key === 'selectedClass') {
                    handleStorageChange();
                }
            });
        };
    }, []);
    useEffect(() => {
    }, [selectedColor]);

    const handleCellClick = (e, rect, index) => {
        e.stopPropagation();
        const previousColor = rect.style.fill;
        rect.style.fill = selectedColor;
        localStorage.setItem(`rect-${index}`, selectedColor);
        setHistory((prevHistory) => [...prevHistory, { index, previousColor, newColor: selectedColor }]);
        setRedoStack([]);
        svgRefs.current.forEach((svgRef, svgIndex) => {
            if (svgIndex !== 8 && svgRef) {
                const rects = svgRef.querySelectorAll('path');
                rects[index].style.fill = selectedColor;
            }
        });
    };

    const handleColorChange = (color) => {
        setSelectedColor(color);
    };

    const handleClear = () => {
        localStorage.setItem('selectedClass', JSON.stringify([]));
        updateFromLocalStorage();
        setHistory([]);
        setRedoStack([]);
    };

    const handleUndo = () => {
        if (history.length === 0) return;

        const lastAction = history.pop();
        setRedoStack((prevRedoStack) => [...prevRedoStack, lastAction]);

        // Update selectedClass
        const selectedClass = JSON.parse(localStorage.getItem('selectedClass')) || [];
        const removedClass = selectedClass.pop();
        localStorage.setItem('selectedClass', JSON.stringify(selectedClass));

        // 🆕 Manually update UI

        updateFromLocalStorage();
    };

    const handleRedo = () => {
        if (redoStack.length === 0) return;

        const lastAction = redoStack.pop();
        const l = JSON.parse(localStorage.getItem('selectedClass')) || [];
        l.push(lastAction); // Just mutate the array

        localStorage.setItem('selectedClass', JSON.stringify(l));
        console.log(redoStack, "REDO");

        setHistory((prevHistory) => { localStorage.setItem('selectedClass', JSON.stringify([...prevHistory, lastAction])); return [...prevHistory, lastAction] });
        setRedoStack([...redoStack]); // Create a new array to trigger state update
        [history, lastAction].forEach((className) => {
            const elements = document.querySelectorAll(`.${className}C`);
            console.log(elements, "elements");
            elements.forEach((element) => {
                element.classList.add('show');
            });
        });

        updateFromLocalStorage();
        // svgRefs.current.forEach((svgRef) => {
        //   if (svgRef) {
        //     const rects = svgRef.querySelectorAll('path');
        //     rects[lastAction.index].style.fill = lastAction.previousColor;
        //     localStorage.setItem(`rect-${lastAction.index}`, lastAction.previousColor);
        //   }
        // });

        // Get the last class from the selectedClass item in localStorage
        const selectedClass = JSON.parse(localStorage.getItem('selectedClass')) || [];
        const removedClass = selectedClass.pop()
        localStorage.setItem('selectedClass', JSON.stringify(selectedClass));
        setSelectedClass(removedClass);
    };
    const First = () => {
        return (
            <div style={{ position: 'relative', width: '100%', padding: '20px' }}>
                <Peacock style={{ width: '120px', height: '120px', position: 'absolute', top: '200px', left: '60px' }} />
                <Line style={{ width: '300px', height: '300px', position: 'absolute', top: '-100px', left: '-55px' }} />
                <Line style={{ width: '300px', height: '300px', position: 'absolute', top: '-100px', right: '-55px' }} />
                <Peacock style={{ width: '120px', height: '120px', position: 'absolute', top: '200px', right: '60px', transform: 'rotateY(180deg)' }} />
                <h1 style={{ fontFamily: 'Jedira', fontWeight: 400, fontSize: '32px', letterSpacing: '0%', margin: '0', textAlign: 'center', color: '#C42026' }}>
                    The Sacred Art of Indian Textile
                </h1>
                <p style={{ fontFamily: 'Jedira', fontStyle: 'italic', fontWeight: 400, marginTop: "-20px", fontSize: '32px', letterSpacing: '0%', textAlign: 'center', color: '#C60307' }}>
                    “Patan Na Patola”
                </p>
                <div>
                    <p style={{ fontFamily: 'GreycliffCF', fontWeight: 400, lineHeight: '15px', fontSize: '13px', letterSpacing: '0%', textAlign: 'center', color: '#C60307' }}>
                        O beloved… O my dear, please bring me <br />
                        an expensive Patola saree from Patan
                    </p>
                    <p style={{ fontFamily: 'GreycliffCF', fontWeight: 400, fontSize: '13px', lineHeight: '15px', letterSpacing: '0%', textAlign: 'center', color: "#929292", marginTop: '-9px', padding: '0' }}>
                        છેલાજી રે… છેલાજી રે મારે હાટુ પાટણથી પટોળાં મોંઘાં લાવજો
                    </p>
                </div>
                <div>
                    <p style={{ fontFamily: 'GreycliffCF', fontWeight: 400, fontSize: '13px', lineHeight: '15px', letterSpacing: '0%', textAlign: 'center', color: '#C60307' }}>
                        And decorate it with dancing peacock motifs<br /> Bring me that fine Patola from Patan
                    </p>
                    <p style={{ fontFamily: 'GreycliffCF', fontWeight: 400, fontSize: '13px', letterSpacing: '0%', marginTop: '-9px', textAlign: 'center', color: "#929292" }}>
                        એમાં રૂડાં રે મોરલિયા ચિતરાવજો, પાટણથી પટોળાં મોંઘાં લાવજો
                    </p>
                </div>
                <div>
                    <p style={{ fontFamily: 'GreycliffCF', fontWeight: 400, fontSize: '13px', letterSpacing: '0%', textAlign: 'center', lineHeight: '15px', color: '#C60307' }}>
                        O beloved… O my dear, please bring me <br />
                        an expensive Patola saree from Patan
                    </p>
                    <p style={{ fontFamily: 'GreycliffCF', fontWeight: 400, fontSize: '13px', letterSpacing: '0%', textAlign: 'center', marginTop: '-9px', color: "#929292" }}>
                        છેલાજી રે… છેલાજી રે મારે હાટુ પાટણથી પટોળાં મોંઘાં લાવજો
                    </p>
                </div>
                <div>
                    <p style={{ fontFamily: 'GreycliffCF', fontWeight: 400, fontSize: '13px', lineHeight: '15px', letterSpacing: '0%', textAlign: 'center', color: '#C60307' }}>
                        Oh beloved one, In rich vibrant red and saffron colors, <br />
                        Let it carry the fragrance of your soul
                    </p>
                    <p style={{ fontFamily: 'GreycliffCF', fontWeight: 400, fontSize: '13px', letterSpacing: '0%', textAlign: 'center', marginTop: '-9px', color: "#929292" }}>
                        રંગ રતુંબલ કોર કસુંબલ, પાલવ પ્રાણ બિછાવજો રે
                    </p>
                </div>
                <div>
                    <p style={{ fontFamily: 'GreycliffCF', fontWeight: 400, fontSize: '13px', letterSpacing: '0%', lineHeight: '15px', textAlign: 'center', color: '#C60307' }}>
                        O beloved… O my dear, please bring me <br />
                        an expensive Patola saree from Patan
                    </p>
                    <p style={{ fontFamily: 'GreycliffCF', fontWeight: 400, fontSize: '13px', letterSpacing: '0%', textAlign: 'center', marginTop: '-9px', color: "#929292" }}>
                        છેલાજી રે… છેલાજી રે મારે હાટુ પાટણથી પટોળાં મોંઘાં લાવજો
                    </p>
                </div>
                <p style={{ fontFamily: 'GreycliffCF', fontWeight: 400, fontSize: '13px', letterSpacing: '0%', textAlign: 'center', margin: 0, marginTop: '60px', padding: 0 }}>
                    Experience heritage reimagined through <br />
                    the timeless art of Patan Na Patola
                </p>
                <div className='button' style={{ display: 'flex', justifyContent: 'center', marginTop: '20px', margin: '0', padding: 0, cursor: 'pointer' }}>
                    <div onClick={() => {
                        handleClick('story', 'story'); setTimeout(() => {
                            setStep(1);
                        }, 300);
                    }} style={{ fontFamily: 'GreycliffCF', boxShadow: clickedButton == 'story' ? clickedShadow : '-3px -3px 6px 0px #FFFFFF, 3px 3px 6px 0px #00000033', padding: '10px', borderRadius: '10px', cursor: 'pointer', marginTop: '20px' }}>
                        Step Into The Story
                    </div>
                </div>

            </div>
        );
    }

    const Second = () => {
        return (
            <div style={{ padding: '25px' }}>
                {/* Left Card Content */}
                <h1 style={{ fontFamily: 'Jedira', fontWeight: 400, fontSize: '32px', letterSpacing: '0%', margin: '0', textAlign: 'center', color: '#929292' }}>
                    The Sacred Art of Indian Textile
                </h1>
                <p style={{ fontFamily: 'Jedira', fontStyle: 'italic', fontWeight: 400, marginTop: "-20px", fontSize: '32px', letterSpacing: '0%', textAlign: 'center', color: '#929292', marginBottom: '0px' }}>
                    “Patan Na Patola”
                </p>
                <div style={{ width: '100%' }}>
                    <h2 style={{ fontFamily: 'Jedira', color: '#C42026', fontSize: '20px', marginBottom: '10px', marginTop: '0px' }}>
                        The Making of The Sacred Cloth
                    </h2>
                    <p style={{ fontFamily: 'GreycliffCF', fontSize: '13px', color: '#929292', marginTop: '-10px', marginBottom: '0px' }}>
                        પટોળા બનાવવાની પવિત્ર કલા
                    </p>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', gap: '60px' }}>
                    <div style={{ flex: '1' }}>

                        <p style={{ fontFamily: 'GreycliffCF', fontSize: '12px', color: '#2E2E2E', marginTop: '15px', lineHeight: '1.5' }}>
                            The history of Patola in Gujarat can be traced back to the 11th century through Maharashtra’s Jaina district. In Patan, King Kumarpal of the Solanki dynasty wore the fabric as a symbol of wealth and faith. The Solanki king brought 700 families of patola weavers from Jaina, south Maharashtra, to Patan.
                        </p>

                        <p style={{ fontFamily: 'GreycliffCF', fontSize: '12px', color: '#2E2E2E', lineHeight: '1.5' }}>
                            The Salvi Caste is the family of weavers. According to its etymology, sal means loom in Sanskrit, and vi means the rosewood part of the loom that ties each weft together. This vi part is key to weaving. That’s how Salvi got its name.
                        </p>

                        <p style={{ fontFamily: 'GreycliffCF', fontSize: '12px', color: '#2E2E2E', lineHeight: '1.5' }}>
                            There are many traditional textile centers in India, including patola weavers around the world. Among them are<b> (a) The patola of Patan, Gujarat, (b) Samb & Puspapalli ikat of Orissa and Andhra Pradesh</b>. These states were chronologically arranged, with Patola woven first in <b>Gujarat</b>, then in <b>Orissa</b>, and then in <b>Andhra Pradesh</b>.
                        </p>

                    </div>
                    <div style={{ flex: '1' }}>
                        <p style={{ fontFamily: 'GreycliffCF', fontSize: '12px', color: '#2E2E2E', lineHeight: '1.5' }}>
                            A patola is made by resist-dyeing using the <b>warp</b> and <b>weft</b> technique. In addition to tilting to one side, the patola loom requires two people to work together to weave a sari.
                        </p>

                        <p style={{ fontFamily: 'GreycliffCF', fontSize: '12px', color: '#2E2E2E', lineHeight: '1.5' }}>
                            It usually takes three people and four to seven months to weave a patola, making it an expensive and time-consuming process. In order to adjust the yarns, a sword-shaped stick made of rosewood is called <b>vi</b>.
                        </p>

                        <p style={{ fontFamily: 'GreycliffCF', fontSize: '12px', color: '#2E2E2E', lineHeight: '1.5' }}>
                        To begin, tie the yarn with cotton threads following the pattern. The measurements can be as small as <b>1/100th</b> of an inch.<br />
The yarn is tied and dyed multiple times, following an order of colours. In a design, every colour has a unique position, which needs to be carefully aligned while weaving. It can also take up
to a year to make these pieces, depending on the length and complexity of the pattern.

                        </p>
                    </div>
                </div>
                <div>
                    <h3 style={{ fontFamily: 'Jedira', color: '#C42026', fontSize: '16px', marginTop: '0px' }}>
                        The Salvi Community
                    </h3>
                    <p style={{ fontFamily: 'GreycliffCF', fontSize: '13px', color: '#929292', marginTop: '-10px', marginBottom: '0px' }}>
                        સાલવી કુળ
                    </p>
                </div>


                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '60px' }}>
                    <div style={{ flex: '1' }}>

                        <p style={{ fontFamily: 'GreycliffCF', fontSize: '12px', color: '#2E2E2E', lineHeight: '1.5', margin: 0, marginTop: '10px' }}>
                            <b>Salvi</b> trace their origins back to the word <b>Sal</b>, which means <b>loom</b>. They have long been associated with silk weaving. In Patan, the Salvi-own circle of relatives of weavers separated into four companies in 1965.
                        </p>
                    </div>
                    <div style={{ flex: '1' }}>
                        <p style={{ fontFamily: 'GreycliffCF', fontSize: '12px', color: '#2E2E2E', lineHeight: '1.5', margin: 0 }}>
                            The renovation and continuation of the <b>patola</b> fabric artwork shape has now been surpassed by <b>35 generations</b> inside the <b>Salvi</b> own circle of relatives of Patan.
                        </p>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'end', marginTop: '0px' }}>
                    <p
                        onClick={() => setStep(4)}
                        style={{
                            margin: 0,
                            color: '#929292',
                            justifyContent: 'center',
                            textAlign: 'end',
                            alignSelf: 'end',
                            cursor: 'pointer',
                            fontFamily: 'GreycliffCF',
                            fontSize: '14px',
                        }}
                    >
                        Skip
                    </p>
                </div>
            </div>
        );
    };

    const Third = () => {
        return (
            <div style={{ padding: '25px' }}>
                <h1 style={{ fontFamily: 'Jedira', fontWeight: 400, fontSize: '32px', letterSpacing: '0%', margin: '0', textAlign: 'center', color: '#929292' }}>
                    The Sacred Art of Indian Textile
                </h1>
                <p style={{ fontFamily: 'Jedira', fontStyle: 'italic', fontWeight: 400, marginTop: "-20px", fontSize: '32px', letterSpacing: '0%', textAlign: 'center', color: '#929292', marginBottom: '0px' }}>
                    “Patan Na Patola”
                </p>
                {/* Title */}
                <div>
                    <h2 style={{ fontFamily: 'Jedira', color: '#C42026', fontSize: '20px', marginBottom: '10px' }}>
                        Design & Motifs of the Traditional Craft
                    </h2>
                    <p style={{ fontFamily: 'GreycliffCF', fontSize: '13px', color: '#929292', marginTop: '-10px' }}>
                        પવિત્ર કળાના નમૂના અને આકારો
                    </p>
                </div>

                {/* Content Rows */}
                <div style={{ display: 'flex', flexDirection: 'row', gap: '60px' }}>
                    {/* Left Column */}
                    <div style={{ flex: '1' }}>
                        <p style={{ fontFamily: 'GreycliffCF', fontSize: '12px', color: '#2E2E2E', lineHeight: '1.5' }}>
                            There is an intensity of design and color in the traditional weave of Patola. Pre-designed motifs appear repeatedly throughout the repeated stripe process. These are known as <b>Bhat</b> (designs).
                        </p>

                        <p style={{ fontFamily: 'GreycliffCF', fontSize: '12px', color: '#2E2E2E', lineHeight: '1.5' }}>
                            Weaving ends are usually left unwoven, especially on sarees. The first is that it serves as an indication of authenticity to the buyer. Second, the buyer can choose which knot design they like as many different designs are available.
                        </p>

                        <p style={{ fontFamily: 'GreycliffCF', fontSize: '12px', color: '#2E2E2E', lineHeight: '1.5' }}>
                            An absolute royal weave, <b>Navratna</b> consists of nine motifs representing gems/jewel. Hinduism and Hindu astrology worship nine celestial bodies and deities known as <b>Navagrahas</b>. The elephant is often shown within a patola as a motif, and is considered a symbol of royalty.
                        </p>

                        <p style={{ fontFamily: 'GreycliffCF', fontSize: '12px', color: '#2E2E2E', lineHeight: '1.5' }}>
                            There will usually be four repetitions of the same design motif on a saree when it features an elaborate, <b>royal elephant</b> motif. The colour of the <b>elephant</b> is always white. This is probably a symbol of auspiciousness and peace. Most motifs with a series of three, and those other motifs of the same size: the <b>paari</b>, the <b>parrot</b>, and the <b>flower</b>.
                        </p>
                    </div>

                    {/* Right Column */}
                    <div style={{ flex: '1' }}>
                        <p style={{ fontFamily: 'GreycliffCF', fontSize: '12px', color: '#2E2E2E', lineHeight: '1.5' }}>
                            Each of them comprises a <b>quadratpartite motif</b>. The main motifs range from ten to twelve, and some blend together. You can choose between half, single, triple, and five (penta) flower combinations, though in most cases they will all be the same if the design is composed of more than one flower, as the principal design on a patola. There are two types of border in some designs: <b>Vertical</b> and <b>Round.</b>
                        </p>

                        <p style={{ fontFamily: 'GreycliffCF', fontSize: '12px', color: '#2E2E2E', lineHeight: '1.5' }}>
                            <b>Main Designs of Patola are:</b><br /><br />
                            • <b>Chokadi Bhat</b> <span style={{ color: '#929292' }}>Geometrical Flower Pattern</span><br />
                            • <b>Chadbadi Bhat</b> <span style={{ color: '#929292' }}>Flowering Pattern</span><br />
                            • <b>Paan Bhat</b> <span style={{ color: '#929292' }}>Leaf Pattern</span><br />
                            • <b>Phul Bhat</b> <span style={{ color: '#929292' }}>Woven motifs</span><br />
                            • <b>Navratna Bhat</b> <span style={{ color: '#929292' }}>Nine Jewel Pattern</span><br />
                            • <b>Sankli Bhat</b> <span style={{ color: '#929292' }}>Chain Pattern</span><br />
                            • <b>Vohra Gaji Bhat</b>  <span style={{ color: '#929292' }}>Vohra Community Pattern</span><br />
                            • <b>Kamal Bhat</b> <span style={{ color: '#929292' }}>Lotus Pattern</span><br />
                            • <b>Nari Kunjar Bhat</b> <span style={{ color: '#929292' }}>Elephant Pattern</span>
                        </p>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'end', marginTop: '0px' }}>
                    <p
                        onClick={() => setStep(4)}
                        style={{
                            margin: 0,
                            color: '#929292',
                            justifyContent: 'center',
                            textAlign: 'end',
                            alignSelf: 'end',
                            cursor: 'pointer',
                            fontFamily: 'GreycliffCF',
                            fontSize: '14px',
                        }}
                    >
                        Skip
                    </p>
                </div>
            </div>
        );
    };

    const Fourth = () => {
        return (
            <div style={{ padding: '25px' }}>
                <h1 style={{ fontFamily: 'Jedira', fontWeight: 400, fontSize: '32px', letterSpacing: '0%', margin: '0', textAlign: 'center', color: '#929292' }}>
                    The Sacred Art of Indian Textile
                </h1>
                <p style={{ fontFamily: 'Jedira', fontStyle: 'italic', fontWeight: 400, marginTop: "-20px", fontSize: '32px', letterSpacing: '0%', textAlign: 'center', color: '#929292', marginBottom: '0px' }}>
                    “Patan Na Patola”
                </p>

                {/* Beliefs Section */}

                <div>
                    <h2 style={{ fontFamily: 'Jedira', color: '#C42026', fontSize: '20px', marginBottom: '10px', marginTop: '0px' }}>
                        Beliefs associated with Patola
                    </h2>
                    <p style={{ fontFamily: 'GreycliffCF', fontSize: '13px', color: '#929292', marginTop: '-10px', marginBottom: '0px' }}>
                        પટોળા સાથે જોડાયેલી માન્યતાઓ
                    </p>
                </div>

                <div style={{ display: 'flex', flexDirection: 'row', gap: '60px', marginTop: '10px' }}>
                    <div style={{ flex: 1 }}>
                        <p style={{ fontFamily: 'GreycliffCF', fontSize: '12px', color: '#2E2E2E', lineHeight: '1.5', marginTop: 0 }}>
                            Several communities believe that <b>Patolas</b> have magical properties that ward off evil and are therefore essential in ceremonies.
                            <b>Patolas</b> are significant to many religious groups such as <b>Nagar Brahmins, Jains, and Vohra Muslims</b>.
                        </p>

                        <p style={{ fontFamily: 'GreycliffCF', fontSize: '12px', color: '#2E2E2E', lineHeight: '1.5' }}>
                            <i>Jain</i> weavers use the color red to symbolize the mother goddess they worship. The <b>chabadi bhaat</b> (basket pattern) includes a circle of lotus flowers, buds, and leaves, and is associated with fertility and is worn during wedding ceremonies in some cultures.
                        </p>
                    </div>

                    <div style={{ flex: 1 }}>
                        <p style={{ fontFamily: 'GreycliffCF', fontSize: '12px', color: '#2E2E2E', lineHeight: '1.5', marginTop: 0 }}>
                            During the <b>shrimanta (baby shower)</b> ceremony, pregnant women were given Patolas with patterns that depicted <b>dancing figures, parrots, or elephants</b> to protect them against evil. In the past, saris that were no longer in use were re-used in different ways, such as <b>quilts</b> for children or <b>cradles</b> for babies, since they still had power.
                        </p>

                        <p style={{ fontFamily: 'GreycliffCF', fontSize: '12px', color: '#2E2E2E', lineHeight: '1.5' }}>
                            Since time immemorial, textiles have had the ability to cross religious boundaries and have taken on distinct meanings through this ritual.
                        </p>
                    </div>
                </div>

                {/* Archaeological Evidence */}
                <div style={{ marginTop: '30px' }}>
                    <h2 style={{ fontFamily: 'Jedira', color: '#C42026', fontSize: '20px', marginBottom: '10px' }}>
                        Archaeological evidence
                    </h2>
                    <p style={{ fontFamily: 'GreycliffCF', fontSize: '13px', color: '#929292', marginTop: '-10px', marginBottom: '0px' }}>
                        પુરાતત્વિક પુરાવા
                    </p>
                </div>

                <div style={{ display: 'flex', flexDirection: 'row', gap: '60px', marginTop: '10px' }}>
                    <div style={{ flex: 1 }}>
                        <p style={{ fontFamily: 'GreycliffCF', fontSize: '12px', color: '#2E2E2E', lineHeight: '1.5', marginTop: 0 }}>
                            The <i>Ikat</i> weaving tradition in India can trace its roots back to the <b>11th century</b>. Here are some archaeological finds illustrating how India's traditional textiles have been represented throughout the world (including other Indian states and countries of the world).
                        </p>

                        <p style={{ fontFamily: 'GreycliffCF', fontSize: '12px', color: '#2E2E2E', lineHeight: '1.5' }}>
                            <i>Ikat</i> textiles dating back to the <b>6th and 7th centuries</b> have been preserved in <i>Japan</i> (from Central Asia). The <b>12th-century</b> silk fragment was found in <i>Persia</i> (Rayy), similar to the <i>Indian Double Ikat Patola</i>. Egyptian textiles dating from the <b>Middle Ages (14th–15th century)</b> were found to be made of cotton Ikat.
                        </p>
                    </div>

                    <div style={{ flex: 1 }}>
                        <p style={{ fontFamily: 'GreycliffCF', fontSize: '12px', color: '#2E2E2E', lineHeight: '1.5', marginTop: 0 }}>
                            <b>Cave I</b> of <b>Ajanta</b> (<b>6th–7th century</b>) depicts robes with resist patterning (<i>Ikat</i>). Paintings <i>Mattancheri, Padmanabhapuram, Pundarikapuram</i>, etc. have clear examples of <b>Patola</b>. The location of these places is in <b>Kerala</b> (<b>Malabar, Cochin, and Travancore</b>).
                        </p>
                    </div>
                </div>


            </div>
        );
    };

    const Fifth = () => {
        return (
            <div style={{ width: "100%", padding: '20px' }}>
                <p style={{ fontFamily: 'Grey', color: '#929292', fontSize: '12px', marginBottom: '10px' }}>
                    Choose the pattern you like!
                </p>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', columnGap: '100px', marginTop: '-15px', padding: '10px' }}>
                    {[
                        { label: 'Geometric Floral Pattern', gujarati: 'ચોખઠા ભાત', Component: FirstP, data: firstPdata, grid: "first" },
                        { label: 'Basket Pattern', gujarati: 'છાબડી ભાત', Component: SecondP, data: secondPdata, grid: "second" },
                        { label: 'Leaf Pattern', gujarati: 'પાન ભાત', Component: ThirdP, data: thirdPdata, grid: 'third' },
                        { label: 'Nine Jewel Pattern', gujarati: 'નવરત્ન ભાત', Component: FourthP, data: fourthPdata, grid: 'fourth' },
                        { label: 'Chain Pattern', gujarati: 'સાંકળી ભાત', Component: FifthP, data: fifthPdata, grid: 'fifth' },
                        { label: 'Flower Pattern', gujarati: 'ફૂલ ભાત', Component: SixthP, data: sixthPdata, grid: 'sixth' },
                    ].map((pattern, index) => {
                        const PatternComponent = pattern.Component;
                        return (
                            <div
                                key={index}
                                style={{ cursor: 'pointer' }}
                                onClick={(el) => {
                                    // Apply grayscale filter to the image wrapper
                                    const wrapper = el.currentTarget.querySelector('.pattern-wrapper');
                                    if (wrapper) {
                                        wrapper.classList.add('grayscale');
                                        setTimeout(() => {
                                            wrapper.classList.remove('grayscale');
                                        }, 300);
                                    }

                                    // Update state and localStorage
                                    setSelectPattern({
                                        pattern: pattern.Component,
                                        data: pattern.data,
                                        grid: pattern.grid,
                                    });
                                    setTimeout(() => {index!=4&&setStep(step + 1)}, 30);
                                    localStorage.setItem('grid', pattern.grid);
                                }}
                            >
                                <div style={{ margin: '0' }}>
                                    <div className="pattern-wrapper">
                                        <PatternComponent style={{ width: '100%', height: 'auto' }} />
                                    </div>
                                </div>

                                <p
                                    style={{
                                        fontFamily: 'Jedira',
                                        fontSize: '14px',
                                        marginTop: '10px',
                                        textAlign: 'center',
                                    }}
                                >
                                    {pattern.label}
                                </p>

                                <p
                                    style={{
                                        fontFamily: 'NotoSerifGujarati',
                                        fontSize: '13px',
                                        color: '#7A7A7A',
                                        marginTop: '-18px',
                                        textAlign: 'center',
                                    }}
                                >
                                    {pattern.gujarati}
                                </p>
                            </div>

                        );
                    })}
                </div>
            </div>
        );
    }

    return (
        <>
            <Container>
                <div className="App" style={{ width: '100%', padding: '0 20px' }}>
                    <header className="App-header" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <LogoStyled className="App-logo" style={{ width: '190px' }} />

                        </div>
                        <div>
                            <p onClick={() => setStep(0)} style={{ fontSize: '14px', color: '#929292', margin: 0, padding: 0, font: 'normal normal 300 14px "Greycliff CF", sans-serif', cursor: 'pointer' }}>
                                Back To Home
                            </p>
                        </div>
                    </header>
                    <div style={{ display: 'flex',position:'relative', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', gap: "30" }}>
                        <div style={{ flex: 1, width: '50%', height: '100%', marginBottom: "-100px", paddingRight: '20px' }}>
                            <SideCard style={{ position: 'relative', overflow: 'hidden', height: '100%', width: '100%', backgroundColor: '#F7F7F7', borderRadius: '10px', padding: '0px', margin: '0px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', marginBottom: '0px' }}>
                                {step === 0 ? <First /> : step === 1 ? <Second /> : step === 2 ? <Third /> : step === 3 ? <Fourth /> : step === 4 ? <Fifth /> : <Patterns PatternSVG={selectedPattern.pattern} patternData={selectedPattern.data} setSelectedColor={setSelectedColor} setIndices={setIndices} setHistory={setHistory} setRedoStack={setRedoStack} />}
                            </SideCard>
                            {step > 0 && (
                                <div style={{ display: "flex", justifyContent: 'end', gap: '10px' }}>
                                    {step > 0  && (<div>
                                        <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', height: '100%' }}>
                                            <div
                                                onClick={() => {
                                                    handleClick('back', 'back'); setTimeout(() => {
                                                        setStep((prevStep) => (prevStep - 1 + 6) % 6);
                                                    }, 300);
                                                }}
                                                style={{ boxShadow: clickedButton == "back" ? clickedShadow : defaultShadow, padding: '10px', borderRadius: '10px', cursor: 'pointer', display: 'flex', marginTop: '15px' }}>
                                                <ArrowForward style={{ transform: 'rotate(180deg)' }} />
                                            </div>
                                        </div>
                                    </div>)}
                                    {(step!=4&&step!=5)&&(<div style={{ cursor: 'pointer' }}>
                                        <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', height: '100%' }}>
                                            <div
                                                onClick={() => {
                                                    handleClick('forward', 'forward'); setTimeout(() => {
                                                        setStep((prevStep) => (prevStep + 1) % 6);
                                                    }, 300);
                                                }}
                                                style={{ boxShadow: clickedButton == "forward" ? clickedShadow : defaultShadow, padding: '10px', borderRadius: '10px', cursor: 'pointer', display: 'flex', marginTop: '15px' }}>
                                                {step == 3 ? "Explore Pixel Design" : (<ArrowForward />)}
                                            </div>
                                        </div>
                                    </div>)}
                                </div>
                            )}
                              <div style={{ textAlign: 'left', marginTop: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px', fontFamily: 'GreycliffCF', fontSize: '12px', color: '#929292', position: 'absolute', bottom: '0', left: '0px',bottom:'-135px', padding: '10px' }}>
                <p>© 2025</p> | <p> Sai Sandeep Ramavath</p> |
                <a href="https://www.linkedin.com/in/saisandeepramavath" target="_blank" style={{ color: '#929292', textDecoration: 'none' }}>https://www.linkedin.com/in/saisandeepramavath</a> |
                <a href="https://github.com/saisandeepramavath" target="_blank" style={{ color: '#929292', textDecoration: 'none' }}>https://github.com/saisandeepramavath</a> |
                <a href="mailto:sr3249@rit.edu" style={{ color: '#929292', textDecoration: 'none' }}>sr3249@rit.edu</a>

            </div>
                        </div>

                        <div style={{ height: "650px", display: 'flex', flexDirection: 'column', position: 'relative' }}>
                            {/* Control Buttons */}
                            <div style={{ marginRight: '30px' }}>
                                <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', width: '100%', gap: '20px' }}>

                                    {/* Undo Button */}
                                    <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                                        <div
                                            onClick={() => handleClick('undo', handleUndo)}
                                            style={{
                                                boxShadow: clickedButton === 'undo' ? clickedShadow : defaultShadow,
                                                padding: '6px',
                                                borderRadius: '10px',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                transition: 'box-shadow 0.2s ease'
                                            }}
                                        >
                                            <Undo />
                                        </div>
                                    </div>

                                    {/* Redo Button */}
                                    <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', height: '100%' }}>
                                        <div
                                            onClick={() => handleClick('redo', handleRedo)}
                                            style={{
                                                boxShadow: clickedButton === 'redo' ? clickedShadow : defaultShadow,
                                                padding: '6px',
                                                borderRadius: '10px',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                transition: 'box-shadow 0.2s ease'
                                            }}
                                        >
                                            <Redo />
                                        </div>
                                    </div>

                                    {/* Clear Button */}
                                    <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', height: '100%' }}>
                                        <div
                                            onClick={() => handleClick('clear', handleClear)}
                                            style={{
                                                boxShadow: clickedButton === 'clear' ? clickedShadow : defaultShadow,
                                                padding: '6px',
                                                borderRadius: '10px',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                transition: 'box-shadow 0.2s ease'
                                            }}
                                        >
                                            <Close />
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {
                                    selectedPattern.grid == "first" && (
                                        <FirstpC
                                            style={{ height: '100%', width: "100%", objectFit: 'contain', width: '100%', cursor: 'pointer' }}

                                            ref={(el) => (svgRefs.current[0] = el)}

                                        />
                                    )
                                }
                                {selectedPattern.grid == "second" && <SecondpC
                                    style={{ height: '100%', width: "100%", objectFit: 'contain', width: '100%', cursor: 'pointer' }}

                                    ref={(el) => (svgRefs.current[0] = el)}
                                />}
                                {selectedPattern.grid == "third" && <ThirdpC
                                    style={{ height: '100%', width: "100%", objectFit: 'contain', width: '100%', cursor: 'pointer' }}

                                    ref={(el) => (svgRefs.current[0] = el)}
                                />}
                                {selectedPattern.grid == "fourth" && <FourthpC
                                    style={{ height: '100%', width: "100%", objectFit: 'contain', width: '100%', cursor: 'pointer' }}
                                    ref={(el) => (svgRefs.current[0] = el)}
                                />}
                                {selectedPattern.grid == "fifth" && <FifthpC
                                    style={{ height: '100%', width: "100%", objectFit: 'contain', width: '100%', cursor: 'pointer' }}
                                    ref={(el) => (svgRefs.current[0] = el)}
                                />} {selectedPattern.grid == "sixth" && <SixthpC
                                    style={{ height: '100%', width: "100%", objectFit: 'contain', width: '100%', cursor: 'pointer' }}
                                    ref={(el) => (svgRefs.current[0] = el)}
                                />}
                                {!selectedPattern.grid && (<FirstpC
                                    style={{ height: '100%', width: "100%", objectFit: 'contain', width: '100%', cursor: 'pointer' }}

                                    ref={(el) => (svgRefs.current[0] = el)}

                                />)}


                                <div style={{ height: '650px', marginLeft: '20px', position: 'relative' }}>
                                    <Slider
                                        onMouseDown={(e) => {
                                            const slider = e.target;
                                            const parentRect = slider
                                            const onMouseMove = (moveEvent) => {

                                                let newTop;
                                                const currentBottom = parseInt(slider.style.bottom.slice(0, -2)) || 0;
                                                if (currentBottom <= 550) {
                                                    newTop = currentBottom + 3;
                                                }
                                                slider.style.bottom = `${newTop}px`;
                                            };

                                            const onMouseUp = () => {
                                                document.removeEventListener('mousemove', onMouseMove);
                                                document.removeEventListener('mouseup', onMouseUp);
                                            };
                                            document.addEventListener('mousemove', onMouseMove);
                                            document.addEventListener('mouseup', onMouseUp);
                                            slider.style.cursor = 'grabbing';
                                        }}
                                        style={{
                                            position: 'absolute',
                                            bottom: '-50px',
                                            width: '20px',
                                            left: '-6px',
                                            cursor: 'pointer',
                                        }}
                                    />
                                    <SideBar style={{ height: '100%' }} />
                                </div>

                            </div>
                            <div>
                                <div style={{ display: 'flex', justifyContent: 'end', marginRight: '30px', alignItems: 'center', height: '100%', bottom: 0 }}>
                                    <div
                                        onClick={() => { setIsDownloadModalOpen(true); setStep((prevStep) => (prevStep + 1) % 5) }}
                                        style={{ fontFamily: 'GreycliffCF', boxShadow: '-3px -3px 6px 0px #FFFFFF, 3px 3px 6px 0px #00000033', padding: '10px', borderRadius: '10px', cursor: 'pointer', display: 'flex', marginTop: '10px' }}>
                                        Download Pattern
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>


            </Container>
          

            <DownloadModal isDownloadModalOpen={isDownloadModalOpen} setIsDownloadModalOpen={setIsDownloadModalOpen}    />

        </>
    );
}


const Container = styled.div`  
  width: 100%;
  padding: 10px;
  display: flex;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
`;


const SideCard = styled.div`
box-shadow: -3px -3px 3px 0px #FFFFFF;
margin: 0px 30px 0px 0px;
padding: 20px;
background: #F7F5F5;
height:600px;
display: flex;
align-items: center;
justify-content: center;

flex-direction: row;
min-width: 400px;
box-shadow: 3px 3px 5px 0px #00000033;
border-radius: 25px; 

}`;

const Title = styled.p`
  margin: 0;
  padding: 0;
  font: normal normal 300 22px 'Greycliff CF', sans-serif;
`;

const LogoStyled = styled(Logo)`
  width: 60px;
  height: 60px;

`;


const Sub = styled.p`
  margin: 0;
  padding: 0;
  font: normal normal 300 8px 'Greycliff CF', sans-serif;
`;
export default App;
